var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('rc-data-table',{ref:"rcTable",attrs:{"data":_vm.data,"but":_vm.rcButList,"delete-api":_vm.deleteApi,"form":{
      form: _vm.form,
      data: _vm.formData,
      formItem: _vm.formItem
    },"columns":_vm.tableColumns || _vm.column || _vm.tableColumns,"api":_vm.api,"params":_vm.params,"dialog":_vm.dialog1 || _vm.dialog}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }